export const NotificationTypes = {
    onboarding: 'onboarding',
}
